import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ChartTextContainer = styled.div`
  padding: 20px 40px 0;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding: 0 80px;
  }
`;
